// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider_container_zUJxU {
  margin: 8px;
  height: 22px;
  width: 150px;
  position: relative;
  outline: none;
  border-radius: 11px;
  margin-bottom: 16px;
}

.slider_last_Y7Nz6 {
  margin-bottom: 4px;
}

.slider_handle_DOMJn {
  left: 100px;
  width: 26px;
  height: 26px;
  margin-top: -2px;
  position: absolute;
  background-color: white;
  border-radius: 100%;
  -webkit-box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.15);
          box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.15);
  -ms-touch-action: none;
      touch-action: none;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/forms/slider.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;EACjD,sBAAsB;MAClB,kBAAkB;AACxB","sourcesContent":[".container {\n  margin: 8px;\n  height: 22px;\n  width: 150px;\n  position: relative;\n  outline: none;\n  border-radius: 11px;\n  margin-bottom: 16px;\n}\n\n.last {\n  margin-bottom: 4px;\n}\n\n.handle {\n  left: 100px;\n  width: 26px;\n  height: 26px;\n  margin-top: -2px;\n  position: absolute;\n  background-color: white;\n  border-radius: 100%;\n  -webkit-box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.15);\n  -ms-touch-action: none;\n      touch-action: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `slider_container_zUJxU`,
	"last": `slider_last_Y7Nz6`,
	"handle": `slider_handle_DOMJn`
};
export default ___CSS_LOADER_EXPORT___;
